import { t } from "i18next";

import { ValueType } from "#modules/similarPart/view/filters/FilterPropertyInputController";
import { Operator } from "shared";

export const getPropertyOptions = ({ hasDimensionsFilter }: { hasDimensionsFilter: boolean }) => {
  const propertyOptions = hasDimensionsFilter
    ? defaultPropertyOptions.concat([
        {
          value: "dimensions",
          label: t("similarPart.propertyOptions.dimensions"),
          type: "percentage",
          operators: ["NEAR"],
        },
      ])
    : defaultPropertyOptions;

  return propertyOptions;
};

const defaultPropertyOptions: {
  value: string;
  label: string;
  type: ValueType;
  operators: Operator[];
}[] = [
  {
    value: "name",
    label: t("similarPart.propertyOptions.name"),
    type: "text",
    operators: ["CONTAINS", "NOT_CONTAINS", "EQUAL", "NOT_EQUAL"],
  },
  {
    value: "dimensions",
    label: t("similarPart.propertyOptions.dimensions"),
    type: "percentage",
    operators: ["NEAR"],
  },
  {
    value: "materialGrade",
    label: t("similarPart.propertyOptions.materialGrade"),
    type: "materialGrade",
    operators: ["EQUAL", "NOT_EQUAL"],
  },
  {
    value: "quantity",
    label: t("similarPart.propertyOptions.quantity"),
    type: "number",
    operators: [
      "EQUAL",
      "NOT_EQUAL",
      "LESS_THAN",
      "LESS_THAN_OR_EQUAL",
      "GREATER_THAN",
      "GREATER_THAN_OR_EQUAL",
    ],
  },
  {
    value: "clientId",
    label: t("similarPart.propertyOptions.clientId"),
    type: "client",
    operators: ["EQUAL", "NOT_EQUAL"],
  },
  {
    value: "tubeThickness",
    label: t("similarPart.propertyOptions.tubeThickness"),
    type: "size",
    operators: [
      "EQUAL",
      "NOT_EQUAL",
      "LESS_THAN",
      "LESS_THAN_OR_EQUAL",
      "GREATER_THAN",
      "GREATER_THAN_OR_EQUAL",
    ],
  },
  {
    value: "height",
    label: t("similarPart.propertyOptions.height"),
    type: "size",
    operators: [
      "EQUAL",
      "NOT_EQUAL",
      "LESS_THAN",
      "LESS_THAN_OR_EQUAL",
      "GREATER_THAN",
      "GREATER_THAN_OR_EQUAL",
    ],
  },
  {
    value: "length",
    label: t("similarPart.propertyOptions.length"),
    type: "size",
    operators: [
      "EQUAL",
      "NOT_EQUAL",
      "LESS_THAN",
      "LESS_THAN_OR_EQUAL",
      "GREATER_THAN",
      "GREATER_THAN_OR_EQUAL",
    ],
  },
  {
    value: "width",
    label: t("similarPart.propertyOptions.width"),
    type: "size",
    operators: [
      "EQUAL",
      "NOT_EQUAL",
      "LESS_THAN",
      "LESS_THAN_OR_EQUAL",
      "GREATER_THAN",
      "GREATER_THAN_OR_EQUAL",
    ],
  },
  {
    value: "tolerance",
    label: t("similarPart.propertyOptions.tolerance"),
    type: "tolerance",
    operators: ["EQUAL", "NOT_EQUAL"],
  },
  {
    value: "processStep",
    label: t("similarPart.propertyOptions.processStep"),
    type: "text",
    operators: ["CONTAINS", "NOT_CONTAINS"],
  },
  {
    value: "surfaceTreatment",
    label: t("similarPart.propertyOptions.surfaceTreatment"),
    type: "text",
    operators: ["CONTAINS"],
  },
  {
    value: "processStep.materialGrade",
    label: t("similarPart.propertyOptions.processStep_materialGrade"),
    type: "text",
    operators: ["CONTAINS"],
  },
  {
    value: "partJson",
    label: t("similarPart.propertyOptions.partJson"),
    type: "feature",
    operators: ["FEATURES_CONTAINS", "FEATURES_NOT_CONTAINS"],
  },
  {
    value: "clientReference",
    label: t("similarPart.propertyOptions.clientReference"),
    type: "text",
    operators: ["EQUAL", "NOT_EQUAL"],
  },
  {
    value: "internalReference",
    label: t("similarPart.propertyOptions.internalReference"),
    type: "text",
    operators: ["EQUAL", "NOT_EQUAL"],
  },
  {
    value: "comment",
    label: t("similarPart.propertyOptions.comment"),
    type: "text",
    operators: ["CONTAINS", "NOT_CONTAINS"],
  },
];
